import type { IEmploymentType } from './types'

export const employmentTypeLabels: Record<keyof IEmploymentType, string> = {
  full_time: 'entity.vacancy.employment_type.full_time',
  part_time: 'entity.vacancy.employment_type.part_time',
  contractor: 'entity.vacancy.employment_type.contractor',
  temporary: 'entity.vacancy.employment_type.temporary',
  intern: 'entity.vacancy.employment_type.intern',
  volunteer: 'entity.vacancy.employment_type.volunteer',
  per_diem: 'entity.vacancy.employment_type.per_diem',
  other: 'entity.vacancy.employment_type.other'
}

export function getActiveEmploymentTypes(employmentType: IEmploymentType): string[] {
  return Object.entries(employmentType)
    .filter(([, value]) => value === true)
    .map(([key]) => employmentTypeLabels[key as keyof IEmploymentType])
}
